<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <div>
        <div class="titleText">核心数据汇总</div>
        <div class="content">
          <div class="filter"></div>
          <div class="tabList">
            <div
              class="tabItem"
              v-for="(item, index) in dateList"
              :key="index"
              :class="{ tabActive: item.id == active }"
              @click="setTab(item)"
            >
              {{ item.name }}
            </div>
            <!-- <div class="updateTime">更新时间：{{updateDate}}</div> -->
          </div>
          <div class="summary">
            <div class="summary_list">
              <div>新增推广专员数</div>
              <div class="summary_list_num">
                <span v-if="topTable && topTable.promoterCount">{{ topTable.promoterCount }}</span>
                <span v-else>0</span>
              </div>
            </div>
            <div class="summary_list">
              <div>累计佣金</div>
              <div class="summary_list_num"> 
                <span v-if="topTable && topTable.sumKickback">{{ topTable.sumKickback }}</span>
                <span v-else>0.00</span>
              </div>
            </div>
            <div class="summary_list">
              <div>推广专员销售额</div>
              <div class="summary_list_num">
                <span v-if="topTable && topTable.sumGoodsAmount">{{ topTable.sumGoodsAmount }}</span>
                <span v-else>0.00</span>
              </div>
            </div>
            <div class="summary_list">
              <div>成交订单数</div>
              <div class="summary_list_num">
                <span v-if="topTable && topTable.totalOrders">{{ topTable.totalOrders }}</span>
                <span v-else>0</span>
              </div>
            </div>
            <div class="summary_list">
              <div>支出佣金（元）</div>
              <div class="summary_list_num">
                <span v-if="topTable && topTable.totalWithdrawn">{{ topTable.totalWithdrawn }}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="titleText ontop">推广专员排行榜</div>
        <div class="dateSelect">
          <div class="dateSelect_item">自然日</div>
          <a-date-picker style="width: 15%" v-model="form.time1" valueFormat="YYYY-MM-DD" allow-clear @change="getMiddleTableList"/>
        </div>
        <div class="ontable">
          <a-table
            :loading="rankloading"
            rowKey="id"
            :columns="rankColumns"
            :data-source="middleTableList"
            :pagination="false"
          >
          </a-table>
        </div>

        <div class="titleText ontop">商品成交分析</div>
        <div class="dateSelect">
          <div class="dateSelect_item">自然日</div>
          <a-date-picker style="width: 15%" v-model="form.time2" valueFormat="YYYY-MM-DD" allow-clear  @change="bottomTableByPc"/>
        </div>
        <div class="ontable">
          <a-table
            :loading="rankloading"
            rowKey="id"
            :columns="goodsColumns"
            :data-source="bottonTableList"
            :pagination="false"
          >
          </a-table>
        </div>
      </div>
    </a-card>
  </page-header-wrapper>
</template>

<script>
import { topTableByPc, middleTableByPc, bottomTableByPc } from '@/api/promotion/index'
import { dateTimeStr } from '@/common/date.js'
export default {
  data() {
    return {
      updateDate:'',
      rankloading: false,
      form: {
        time1: '',
        time2: ''
      },
      topTable: {
        promoterCount: 0,
        sumKickback: 0,
        sumGoodsAmount: 0,
        totalOrders: 0,
        totalWithdrawn: 0,
      },
      
      active: 1,
      dateList: [
        {
          id: 1,
          name: '今日',
        },
        {
          id: 2,
          name: '本周',
        },
        {
          id: 3,
          name: '本月',
        },
        {
          id: 4,
          name: '今年',
        },
        {
          id: 5,
          name: '累计',
        },
      ],
      rankColumns: [
        {
          title: '排名',
          dataIndex: 'sortNum',
          align: 'center'
        },
        {
          title: '用户id',
          dataIndex: 'id',
          align: 'center'
        },
        {
          title: '推广专员昵称',
          dataIndex: 'nickName',
          align: 'center'
        },
        {
          title: '累计销售额',
          dataIndex: 'sumGoodsAmount',
          align: 'center'
        },
        {
          title: '累计客户数',
          dataIndex: 'sumUserCount',
          align: 'center'
        },
        {
          title: '支付客户数',
          dataIndex: 'puyerUserCount',
          align: 'center'
        },
        {
          title: '累计邀请数',
          dataIndex: 'sumAddCount',
          align: 'center'
        },
        {
          title: '团队人数',
          dataIndex: 'relationCount',
          align: 'center'
        },
        {
          title: '累计成交订单数',
          dataIndex: 'sumOrderCount',
          align: 'center'
        }
      ],
      goodsColumns: [
        {
          title: '排名',
          dataIndex: 'sortNum',
          align: 'center'
        },
        {
          title: '商品',
          dataIndex: 'goodsName',
          align: 'center'
        },
        {
          title: '成交总额',
          dataIndex: 'sumGoodsAmount',
          align: 'center'
        },
        {
          title: '佣金总额',
          dataIndex: 'goodsKickback',
          align: 'center'
        }
      ],
      middleTableList: [],
      bottonTableList: []
    }
  },
  created() {
    this.middleTableByPc()
    this.bottomTableByPc()
  },
  computed: {},
  watch: {},
  mounted() {
    this.setTab({ id: 1 })
    this.updateDate = dateTimeStr('y-m-d')+" 04:00:00"
  },
  methods: {
    setTab(row) {
       this.active = row.id
        const par = { 'type': row.id }
        topTableByPc(par).then((response) => {
        this.topTable = response.data
      })
    },
    getMiddleTableList() {
        console.log(111);
        
        this.middleTableByPc()
    },
    middleTableByPc() {
        const par = { 'promotionLocalDate': this.form.time1 }
        console.log(par);
        
        middleTableByPc(par).then((response) => {
        this.middleTableList = response.data
      })
    },
    bottomTableByPc() {
        const par = { 'promotionLocalDate': this.form.time2 }
        bottomTableByPc(par).then((response) => {
        this.bottonTableList = response.data
      })
    }
  }
}
</script>

<style scoped>
.titleText {
  font-size: 15px;
  font-weight: bold;
}
.content {
  margin-top: 20px;
}
.filter,
.tabList {
  display: flex;
  align-items: center;
  cursor: pointer;
}
.tabItem {
  padding: 3px 20px;
  border-bottom: 2px solid #fff;
  color: #415058;
}
.tabActive {
  background: #e6f7ff;
  border-color: #1684fc;
  color: #1684fc;
}

.updateTime {
  margin-left: 10px;
  font-size: 15px;
  font-weight: bold;
}

.summary {
  width: 100%;
  display: flex;
  align-items: center;
  color: #333333;
  font-size: 15px;
  margin-top: 20px;
}

.summary_list {
  width: 15%;
  padding: 15px;
  margin-right: 20px;
  font-weight: 700;
  border: 1px solid #d0d0d0;
}
.summary_list_num {
  margin-top: 10px;
  font-size: 30px;
}

.dateSelect {
  margin-top: 10px;
  display: flex;
  align-items: center;
}

.ontop {
  margin-top: 20px;
}

.dateSelect_item {
  font-weight: 700;
  margin-right: 20px;
}
.ontable {
  margin-top: 20px;
}
</style>
